// push to datalayer
/* eslint-disable @typescript-eslint/no-explicit-any */
export const pushToDataLayer = (data: any) => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
};

export const getGA4DataLayerEventByName = (eventName: string): any => {
  if (window && typeof window.dataLayer !== "undefined" && Array.isArray(window.dataLayer)) {
    const dataLayerObject = window.dataLayer.find((obj) =>
      Object.prototype.hasOwnProperty.call(obj, eventName)
    );
    return dataLayerObject ? dataLayerObject[eventName] : null;
  } else {
    console.error("dataLayer is not defined or not an array");
    return null;
  }
};
